var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 7.125C8.64844 7.125 10.5 8.97656 10.5 11.25C10.5 11.6719 10.1484 12 9.75 12H0.75C0.328125 12 0 11.6719 0 11.25C0 8.97656 1.82812 7.125 4.125 7.125H6.375ZM1.125 10.875H9.35156C9.16406 9.39844 7.89844 8.25 6.375 8.25H4.125C2.57812 8.25 1.3125 9.39844 1.125 10.875ZM5.25 6C3.58594 6 2.25 4.66406 2.25 3C2.25 1.35938 3.58594 0 5.25 0C6.89062 0 8.25 1.35938 8.25 3C8.25 4.66406 6.89062 6 5.25 6ZM5.25 1.125C4.19531 1.125 3.375 1.96875 3.375 3C3.375 4.05469 4.19531 4.875 5.25 4.875C6.28125 4.875 7.125 4.05469 7.125 3C7.125 1.96875 6.28125 1.125 5.25 1.125Z",
    fill: "#F92E34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4fb8b996227e5e1017e7255ceec966fb.svg";
export { ForwardRef as ReactComponent };